import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    background: theme.palette.common.white,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
    borderRadius: 8,
    padding: 24,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      background: theme.palette.common.white,
      padding: 24,
      boxShadow: 'none !important',
      borderRadius: '0 !important',
    },
  },
  cardPlace: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0px !important',
    },
  },
  iconGrey: {
    color: theme.palette.secondary.main,
    marginRight: 12,
  },
  title: {
    paddingBottom: 24,
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 16,
    },
  },
  accessBuilding: {
    paddingTop: 8,
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
    },
  },
  building: {
    paddingLeft: 56,
  },
  accesCode: {
    display: 'flex',
  },
  accessBuildingText: {
    paddingLeft: 8,
    color: theme.palette.primary.dark,
  },
}))
